<button
  #originRef
  (click)="showPopover()"
  [class.bg-hover]="dropdownOpen"
  class="button"
  mat-icon-button
  type="button">
  <mat-icon
    [matBadge]="unreadCount"
    [matBadgeHidden]="unreadCount === 0"
    matBadgeColor="warn"
    matBadgeSize="small"
    color="primary"
    svgIcon="mat:notifications_active"></mat-icon>
</button>
